export const EXPLORER_WELCOME_MODAL_STORAGE_KEY = "metricmap.explorer.welcome.dismissed";

export function shouldShowExplorerWelcomeModal(storage: Storage | null | undefined): boolean {
  if (!storage) {
    return true;
  }

  return storage.getItem(EXPLORER_WELCOME_MODAL_STORAGE_KEY) !== "true";
}

export function setExplorerWelcomeModalDismissed(storage: Storage | null | undefined, dismissed: boolean): void {
  if (!storage) {
    return;
  }

  if (dismissed) {
    storage.setItem(EXPLORER_WELCOME_MODAL_STORAGE_KEY, "true");
    return;
  }

  storage.removeItem(EXPLORER_WELCOME_MODAL_STORAGE_KEY);
}
